import analyticsService from "./services/analyticsService";
import deviceFingerprintService from "./services/deviceFingerprintService";
import graphqlMutationService from "./services/graphqlMutationService";
import hostModal from "./services/hostModal";
import configureStore from "./utilities/configureStore";

export default configureStore({
  analyticsService,
  graphqlMutationService,
  deviceFingerprintService,
  hostModal
});
